module.exports = __webpack_public_path__ + "static/media/TerryPorter.7dbc37a5.jpg";